export default __webpack_public_path__ + "static/media/simplonbp-regular-webfont.2d1aa100.ttf";